<script setup lang="ts">
  import { onMounted } from 'vue'
  import { useCookies } from 'vue3-cookies'
  import { useAdminAuthStore } from '@/store/admin/auth'
  import { useUserStore } from '@/store/admin/user'
  import Dashboard from '@/components/admin/dashboard/dashboard.vue'

  const { cookies } = useCookies()
  const { logIn } = useAdminAuthStore()
  const { fetchUser } = useUserStore()
  onMounted(async () => {
    const sessionId = cookies.get('csrftoken')
    if (sessionId) {
      logIn()
      await fetchUser()
    }
  })
</script>

<template>
  <Dashboard />
</template>
